import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "..";
import { Button, FeaturedSelect, Icomoon, Icon } from "../../atoms";
import "./GlobalSearchModal.scss";

interface GlobalSearchModalProps {
  optionsList: { value: string; label: string }[];
}

export const GlobalSearchModal: React.FC<GlobalSearchModalProps> = ({ optionsList }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation("ui");

  return (
    <>
      <Button
        className="is-link"
        element="button"
        onClick={() => setIsOpen(true)}
        aria-label="Open Global Search"
        data-tracking-id="btn.navi.global-search-open">
        <Icon icomoon={Icomoon.search2} />
      </Button>
      <Dialog
        className="global-search-modal"
        contentClassName="p-0"
        isOpen={isOpen}
        ariaLabel="Global Search"
        autoFocus
        closeOnClickOutside
        onClose={() => setIsOpen(false)}
        fullscreenOnMobile={false}>
        {isOpen ? (
          <FeaturedSelect
            id="global-search"
            name="global-search"
            options={optionsList}
            placeholder={t("GlobalSearch_placeholder", "Search for a destination")}
            isSearchable
            noOptionsMessage={() =>
              t("DestinationSelect_noResults", "No results found. Are you sure that's a country?")
            }
            customDropdownIndicator={<Icon icomoon={Icomoon.search2} />}
            disableRotationAnimation
            onChange={(value) => {
              if (value) {
                window.location.href = value.value;
              }
            }}
            autoFocus
          />
        ) : null}
      </Dialog>
    </>
  );
};
